import { GrowthCategory } from '@mc/api'
import { paths } from '@mc/paths'
import { useStaticData } from '@mc/static-data-react'
import { BreadcrumbBar } from 'components/Breadcrumbs'
import { useOutcomePageEvents } from '../utils'

export const CategoryBreadcrumbBar = () => {
  const { primarySubcategory, primaryCategory } = useStaticData<{
    primarySubcategory: GrowthCategory | null
    primaryCategory: GrowthCategory | null
  }>()
  const { trackBreadcrumbClicked } = useOutcomePageEvents()

  if (!primaryCategory || !primarySubcategory) return null

  return (
    <BreadcrumbBar className='mc-my-3'>
      <BreadcrumbBar.Item
        href={paths.category(primaryCategory.slug)}
        onClick={() => trackBreadcrumbClicked(primaryCategory.name, 'category')}
      >
        {primaryCategory.name}
      </BreadcrumbBar.Item>
      <BreadcrumbBar.Separator />
      <BreadcrumbBar.Item
        href={paths.subcategoryPage(primarySubcategory.slug)}
        onClick={() =>
          trackBreadcrumbClicked(primarySubcategory.name, 'subcategory')
        }
      >
        {primarySubcategory.name}
      </BreadcrumbBar.Item>
    </BreadcrumbBar>
  )
}
